import { Dispatch } from '@reduxjs/toolkit';
import { addDays, format } from 'date-fns';
import React from 'react';
import { connect } from 'react-redux';
import { Notification } from 'rsuite';
import { RootState } from '../../../../../@types/RootState';
import { AlertWithTimestamp } from '../../../../../components/AlertWithTimestamp';
import { selectorDatapoints } from '../../../../../reducers/gerenciadorPrecos/datapoints';
import { selectorDemandForecast, SET_IS_OPEN } from '../../../../../reducers/ipa/priceManager/modals/demandForecast';
import { getDemandForecastInputs } from '../../../SimulacoesAnalises/PrevisaoDemanda/v2/services';
import { salvarSimulacao } from '../../services';
import ModalPrevisaoDemanda from '../ModalPrevisaoDemanda';

type DemandForecastModalWrapperProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const DemandForecastModalWrapper = ({ demandForecat: { isOpen, data, selectedForecastIndex }, datapoints, closeModal }: DemandForecastModalWrapperProps) => {
  const handleSaveForecast = React.useCallback(async () => {
    if (!selectedForecastIndex) return;
    const dataContent = datapoints;
    const dataSimulacao = {
      product: {
        id: dataContent[selectedForecastIndex].productId,
        description: dataContent[selectedForecastIndex].description,
        store: {
          id: dataContent[selectedForecastIndex].storeId,
          description: dataContent[selectedForecastIndex].storeName,
        },
      },
      ...dataContent[selectedForecastIndex].demandForecast,
    };
    try {
      const resp = await salvarSimulacao(dataSimulacao);
      if (resp.status !== 201) return;
      Notification.success({
        title: 'Notificação',
        duration: 6000,
        description: (
          <div>
            <p>Simulação salva com sucesso.</p>
          </div>
        ),
      });
      closeModal();
    } catch {
      AlertWithTimestamp({ message: 'Erro ao salvar simulação' });
    }
  }, [selectedForecastIndex, datapoints, closeModal]);

  const handleGoToForecast = React.useCallback(async () => {
    if (selectedForecastIndex == null) return;
    const item = datapoints[selectedForecastIndex];

    const date = [format(new Date(), 'yyyy/MM/dd'), format(addDays(new Date(), 27), 'yyyy/MM/dd')];

    const query = {
      productId: item.productId,
      productName: item.description,
      storeIds: [item.storeId],
      fromDate: new Date(date[0]),
      toDate: new Date(date[1]),
      newPrice: item.demandForecast?.new_price_scenario?.price || 0,
    };

    const { input } = await getDemandForecastInputs({ query });

    const inputMapped = {
      value: item?.demandForecast?.base_price_scenario?.price || input.base_price,
      newPrice: item?.demandForecast?.new_price_scenario?.price || input.new_price,
      priceCanGetNewInput: false,
      margin: input.margin,
      competitiveness: input.competitiveness,
    };

    localStorage.setItem('setInputsValueByGerenciador', JSON.stringify(inputMapped));

    const baseURL = `/ipa/ia/simulacoes-analises/previsao-demanda-v2`;

    const url = `${baseURL}?productId=${item.productId}&storesId=${item.storeId}&price=${item.price}&filterDate=${date[0]}-${date[1]}&source=gerenciador`;
    window.open(url, '_blank');
  }, [selectedForecastIndex, datapoints]);

  return (
    <ModalPrevisaoDemanda show={isOpen} closeModal={closeModal} previsao={data} handleSalvarSimulacao={handleSaveForecast} goToPrevisao={handleGoToForecast} />
  );
};

const mapStateToProps = (state: RootState) => ({
  demandForecat: selectorDemandForecast(state),
  datapoints: selectorDatapoints(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  closeModal: () => dispatch(SET_IS_OPEN(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DemandForecastModalWrapper);
